export default __webpack_public_path__ + "static/media/sentiment_sad.7df2ca49.svg";